module.exports = __webpack_public_path__ + "static/power1-3@2x-c07dbc512d233e551bd32cb17623d43d.png";